"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.84,8.58a1,1,0,0,0-1,1,6.64,6.64,0,0,0,1,2,.06.06,0,0,0,.1,0,6.64,6.64,0,0,0,1-2A1,1,0,0,0,10.84,8.58Zm0,1.46a.45.45,0,0,1,0-.89.45.45,0,0,1,0,.89Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.21,12.74A1.62,1.62,0,0,0,6.6,14.36c0,.85,1.46,3.08,1.53,3.18a.09.09,0,0,0,.08,0,.1.1,0,0,0,.09,0c.06-.1,1.53-2.33,1.53-3.18A1.63,1.63,0,0,0,8.21,12.74Zm0,2.32a.7.7,0,0,1-.71-.7.71.71,0,0,1,1.42,0A.7.7,0,0,1,8.21,15.06Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,10.75a1.35,1.35,0,0,0-1.36,1.35,9,9,0,0,0,1.28,2.67.11.11,0,0,0,.08,0,.11.11,0,0,0,.07,0,9,9,0,0,0,1.28-2.67A1.35,1.35,0,0,0,17,10.75Zm0,1.94a.59.59,0,1,1,.59-.59A.59.59,0,0,1,17,12.69Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.7,12.4a.22.22,0,0,1-.13,0l-2.31-1.54a.24.24,0,0,1-.06-.32.23.23,0,0,1,.32-.07L14.83,12a.24.24,0,0,1,.07.33A.23.23,0,0,1,14.7,12.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.34,15.71a.23.23,0,0,1-.21-.13.24.24,0,0,1,.11-.32l4.68-2.18a.24.24,0,0,1,.31.11.24.24,0,0,1-.11.32l-4.68,2.18A.18.18,0,0,1,10.34,15.71Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,2.5a.5.5,0,0,0-.5-.5H19V4h.5a.5.5,0,0,1,.5.5V17h-4.5a.5.5,0,0,0-.5.5V22H5.47a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,.5-.5H6V2H3.47a.5.5,0,0,0-.5.5v21a.5.5,0,0,0,.5.5h18a.5.5,0,0,0,.5-.5ZM20,18l-4,4V18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.47,2H14.92A2.5,2.5,0,0,0,10,2H7.47a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-3A.5.5,0,0,0,17.47,2Z"
  }));
};

exports["default"] = _default;